/**
 * eg: 72140E5C2019Z08Z19X16C06C382F6102FE3030782
 * @returns {string}
 */
import { fetcher, initValues } from "./fetcher";
import { setMessageWithCode, setUserKey, stopLoading } from "../actions";
import { isLoggedIn } from "./user";

export const login = values => {
  const formData = new FormData();
  Object.keys(values).map(key => formData.append(key, values[key]));

  formData.append("idc", initValues().idc);
  formData.append("cookie", initValues().cookie);
  formData.append("lang", initValues().lang);
  return dispatch => {
    fetcher()
      .post("ajax/connexion_widget_post.php", { body: formData })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;

        if (json.success === 1) {
          dispatch(setUserKey(json.token));
          document.cookie = `workaround_user_session_id=${json.cle_user}`; // @todo remove me please
          dispatch(isLoggedIn());
        } else {
          dispatch(setMessageWithCode({ text: json.message_ajax, code: 0 }));
        }
        dispatch(stopLoading());
      })
      .catch(() => {
        dispatch(stopLoading());
      });
  };
};

export const hash = (dayId, secretPublic) => {
  dayId = parseInt(dayId);
  secretPublic = parseInt(secretPublic);
  const A = 1458;
  const B = 45;
  const C = 1547;
  const E = 5;
  let secretId = "";

  switch (dayId) {
    case 1:
      secretId = (secretPublic + A + B + C) / E;
      break;
    case 2:
      secretId = (secretPublic * A) / B + C / E;
      break;
    case 3:
      secretId = secretPublic - A + B + C / E;
      break;
    case 4:
      secretId = (secretPublic - E - B - C) / A;
      break;
    case 5:
      secretId = (secretPublic * A * B) / (E * C);
      break;
    case 6:
      secretId = secretPublic + (A + A) + E * B;
      break;
    case 7:
      secretId = secretPublic + A + B + C;
      break;
    default:
      secretId = "unknown"; // 17361674 //
  }
  return Math.trunc(secretId);
};

export const forgotPassword = values => {
  return dispatch => {
    const formData = new FormData();
    Object.keys(values).map(key => formData.append(key, values[key]));
    fetcher()
      .post("ajax/envoi_mdp_compte_widget.php", { body: formData })
      .then(response => response.json())
      .then(json => {
        json = Array.isArray(json) ? json[0] : json;
        dispatch(
          setMessageWithCode({ text: json.message_ajax, code: json.success })
        );
      });
  };
};

export const logout = () => {
  return () => {
    document.cookie = "workaround_user_session_id="; // @todo remove me please
  };
};
